(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luma-light-product"]) return;
  try {
    
  function initializeLumaControls(visual) {
    if (!visual) return;
    const states = [...visual.querySelectorAll('[data-luma-setting]')].map(item => item.dataset);
    const playback = visual.querySelector('[data-luma-playback]');
    const next = visual.querySelector('[data-luma-next]');
    const heatLabel = visual.querySelector('[data-luma-picture-heat]');
    const lightLabel = visual.querySelector('[data-luma-picture-light]');
    if (!states.length || !playback || !next || !heatLabel || !lightLabel) return;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const events = new AbortController();
    const listen = {signal:events.signal};
    const lightSequence = [2, 1, 3, 0, 4];
    let index = 0;
    let playing = !motion.matches;
    let visible = !('IntersectionObserver' in window);
    let timer;
    const render = (announce = false) => {
      const heatState = states[index];
      const lightState = states[lightSequence[index]];
      const heatValue = `${heatState.celsius} ${heatState.fahrenheit}`;
      visual.dataset.heatColor = heatState.lumaSetting;
      visual.dataset.lightColor = lightState.lumaSetting;
      heatLabel.textContent = heatValue;
      lightLabel.textContent = lightState.light;
      visual.dataset.playing = String(playing);
      playback.setAttribute('aria-label', playing ? playback.dataset.pauseLabel : playback.dataset.playLabel);
      if (announce) visual.querySelector('[data-luma-picture-status]').textContent = `${heatState.colorName}: ${heatValue}; ${lightState.colorName}: ${lightState.light}`;
    };
    const advance = (announce = false) => {
      index = (index + 1) % states.length;
      render(announce);
    };
    const schedule = () => {
      clearInterval(timer);
      if (!playing || !visible || document.hidden) return;
      timer = setInterval(advance, 2800);
    };
    playback.addEventListener('click', () => { playing = !playing; render(); schedule(); }, listen);
    next.addEventListener('click', () => { playing = false; advance(true); schedule(); }, listen);
    document.addEventListener('visibilitychange', schedule, listen);
    const motionChanged = () => { if (motion.matches) { playing = false; render(); schedule(); } };
    motion.addEventListener('change', motionChanged);
    let observer;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, {threshold:.2});
      observer.observe(visual);
    }
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(visual)) return;
      clearInterval(timer);
      observer?.disconnect();
      motion.removeEventListener('change', motionChanged);
      events.abort();
    }, listen);
    visual.querySelector('[data-luma-picture-tools]').hidden = false;
    render();
    schedule();
  }

  function initializeLumaPurchase(root) {
    const primary = root.querySelector('.luma__add');
    const buttons = [...root.querySelectorAll('[data-luma-purchase]')];
    const feedback = root.querySelector('[data-luma-purchase-feedback]');
    const error = root.querySelector('.product-form__error-message-wrapper');
    if (!primary || !buttons.length) return;
    const synchronize = () => {
      const busy = primary.getAttribute('aria-disabled') === 'true';
      buttons.forEach(button => {
        button.disabled = primary.disabled || busy;
        button.setAttribute('aria-busy', String(busy));
        button.querySelector('.loading__spinner')?.classList.toggle('hidden', !busy);
      });
      if (feedback && error) {
        feedback.textContent = error.textContent.trim();
        feedback.hidden = error.hidden || !feedback.textContent;
      }
    };
    const observer = new MutationObserver(synchronize);
    observer.observe(primary, {attributes:true, attributeFilter:['aria-disabled', 'disabled']});
    if (error) observer.observe(error, {attributes:true, childList:true, characterData:true, subtree:true});
    const unload = event => {
      if (!event.target.contains(root)) return;
      observer.disconnect();
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
    synchronize();
  }

  function initializeLuma(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    initializeLumaPurchase(root);
    initializeLumaControls(root.querySelector('[data-luma-controls]'));
    const image = root.querySelector('[data-luma-main]');
    const thumbnails = [...root.querySelectorAll('[data-luma-thumbnail]')];
    thumbnails.forEach(button => button.addEventListener('click', () => {
      image.srcset = button.dataset.srcset;
      image.src = button.dataset.image;
      image.alt = button.dataset.alt;
      image.width = Number(button.dataset.width);
      image.height = Number(button.dataset.height);
      thumbnails.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      root.querySelector('[data-luma-index]').textContent = `${button.dataset.index.padStart(2, '0')} / ${String(thumbnails.length).padStart(2, '0')}`;
    }));
    thumbnails.forEach((button, index) => button.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? thumbnails.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + thumbnails.length) % thumbnails.length;
      thumbnails[next].focus();
      thumbnails[next].click();
    }));
    const dialog = root.querySelector('[data-luma-dialog]');
    root.querySelector('[data-luma-zoom]').addEventListener('click', () => {
      if (!image) return;
      const enlarged = dialog.querySelector('[data-luma-zoom-image]');
      enlarged.src = image.src;
      enlarged.alt = image.alt;
      dialog.showModal();
    });
    root.querySelector('[data-luma-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
    const video = root.querySelector('[data-luma-video]');
    root.querySelector('[data-luma-watch]')?.addEventListener('click', () => { video?.focus({preventScroll:true}); video?.play().catch(() => {}); });
    const sticky = root.querySelector('[data-luma-sticky]');
    const purchaseButton = root.querySelector('.luma__add');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting; }, {threshold:0});
      observer.observe(purchaseButton);
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) observer.disconnect(); }, {once:true});
    } else {
      const updateSticky = () => {
        const bounds = purchaseButton.getBoundingClientRect();
        sticky.hidden = bounds.bottom > 0 && bounds.top < window.innerHeight;
      };
      updateSticky();
      window.addEventListener('scroll', updateSticky, {passive:true});
      window.addEventListener('resize', updateSticky);
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(root)) return;
        window.removeEventListener('scroll', updateSticky);
        window.removeEventListener('resize', updateSticky);
      }, {once:true});
    }
    const quantity = root.querySelector('[name="quantity"]');
    const normalizeQuantity = () => { quantity.value = Math.min(10, Math.max(1, Math.trunc(Number(quantity.value)) || 1)); };
    root.querySelector('[data-luma-minus]').addEventListener('click', () => { quantity.value = Number(quantity.value) - 1; normalizeQuantity(); });
    root.querySelector('[data-luma-plus]').addEventListener('click', () => { quantity.value = Number(quantity.value) + 1; normalizeQuantity(); });
    quantity.addEventListener('change', normalizeQuantity);
  }
  document.querySelectorAll('[data-luma]').forEach(initializeLuma);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-luma]').forEach(initializeLuma));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medical-review"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-expert-review]').forEach(root => {
      if (root.dataset.reviewReady) return;
      root.dataset.reviewReady = 'true';
      const tabs = [...root.querySelectorAll('[data-review-tab]')];
      const panels = [...root.querySelectorAll('[data-review-panel]')];
      const track = root.querySelector('[data-review-track]');
      const dots = [...root.querySelectorAll('[data-review-dot]')];
      const dock = root.querySelector('[data-review-dock]');
      const dockSlot = root.querySelector('[data-review-dock-slot]');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const controller = new AbortController();
      const listen = (target, type, callback) => target.addEventListener(type, callback, {signal: controller.signal});
      let selectedIndex = 0;
      let pendingIndex = null;
      let scrollFrame;
      let settleTimer;
      let revealAfterScroll = false;
      let navigationFrame;
      let previewToolbar;
      const syncNavigation = () => {
        if (!dock) return;
        const toolbar = document.getElementById('PBarNextFrameWrapper');
        if (toolbar && toolbar !== previewToolbar) { previewToolbar = toolbar; resizeObserver.observe(toolbar); }
        const toolbarBounds = toolbar?.getBoundingClientRect();
        const previewOffset = toolbarBounds && toolbarBounds.bottom >= innerHeight - 1 && toolbarBounds.height < innerHeight / 2 ? Math.max(0, innerHeight - toolbarBounds.top) : 0;
        const trackBounds = track.getBoundingClientRect();
        const mobile = matchMedia('(max-width: 749px)').matches;
        dock.style.left = `${trackBounds.left}px`;
        dock.style.width = `${trackBounds.width}px`;
        if (mobile) dockSlot.style.height = `${dock.offsetHeight}px`;
        const sectionBottom = dockSlot.getBoundingClientRect().bottom;
        const bottom = Math.max(previewOffset, innerHeight - sectionBottom);
        dock.style.bottom = `${bottom}px`;
        const visible = mobile && trackBounds.top < innerHeight - previewOffset - dock.offsetHeight && sectionBottom > 0;
        dock.dataset.reviewDocked = String(visible);
        dock.setAttribute('aria-hidden', String(!visible));
        dock.inert = !visible;
      };
      const queueNavigation = () => { cancelAnimationFrame(navigationFrame); navigationFrame = requestAnimationFrame(syncNavigation); };
      const offsetFor = index => panels[index].offsetLeft - panels[0].offsetLeft;
      const nearestIndex = () => panels.reduce((best, panel, index) => Math.abs(offsetFor(index) - track.scrollLeft) < Math.abs(offsetFor(best) - track.scrollLeft) ? index : best, 0);
      const updateSelection = index => {
        selectedIndex = index;
        tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
        dots.forEach(dot => dot.setAttribute('aria-current', String(Number(dot.dataset.reviewDot) === index)));
        panels.forEach((panel, i) => {
          panel.dataset.reviewActive = String(i === index);
          panel.setAttribute('aria-hidden', String(i !== index));
          panel.inert = i !== index;
          if (i !== index) panel.querySelectorAll('video').forEach(video => video.pause());
        });
      };
      const revealHeading = () => {
        if (!matchMedia('(max-width: 749px)').matches) return;
        const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
        const top = track.getBoundingClientRect().top;
        if (top < headerHeight - 80) window.scrollTo({top: scrollY + top - headerHeight - 12, behavior: 'instant'});
      };
      const finishScroll = () => {
        pendingIndex = null;
        updateSelection(nearestIndex());
        if (revealAfterScroll) revealHeading();
        revealAfterScroll = false;
      };
      const select = (index, {focusTab = false, focusDot = false, reveal = false} = {}) => {
        index = Math.max(0, Math.min(index, panels.length - 1));
        pendingIndex = index;
        revealAfterScroll = false;
        updateSelection(index);
        track.scrollTo({left: offsetFor(index), behavior: motion.matches ? 'instant' : 'smooth'});
        if (reveal) revealHeading();
        if (focusTab) tabs[index]?.focus({preventScroll: true});
        if (focusDot) dots.find(dot => Number(dot.dataset.reviewDot) === index)?.focus({preventScroll: true});
        if (Math.abs(track.scrollLeft - offsetFor(index)) < 1) finishScroll();
      };
      const loadPortraits = () => root.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
      let portraitObserver;
      if ('IntersectionObserver' in window) {
        portraitObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { loadPortraits(); portraitObserver.disconnect(); }
        }, {rootMargin: '400px'});
        portraitObserver.observe(root);
      } else loadPortraits();
      listen(track, 'pointerdown', () => { pendingIndex = null; });
      listen(track, 'scroll', () => {
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(() => {
          if (pendingIndex !== null && Math.abs(track.scrollLeft - offsetFor(pendingIndex)) > 1) return;
          const nearest = nearestIndex();
          if (nearest !== selectedIndex) { revealAfterScroll = true; updateSelection(nearest); }
        });
        if (!('onscrollend' in track)) {
          clearTimeout(settleTimer);
          settleTimer = setTimeout(finishScroll, 150);
        }
      });
      listen(track, 'scrollend', finishScroll);
      const keyboardTarget = (key, index) => {
        if (key === 'ArrowRight') return (index + 1) % panels.length;
        if (key === 'ArrowLeft') return (index - 1 + panels.length) % panels.length;
        if (key === 'Home') return 0;
        if (key === 'End') return panels.length - 1;
      };
      tabs.forEach((tab, index) => {
        listen(tab, 'click', () => select(index));
        listen(tab, 'keydown', event => {
          const target = keyboardTarget(event.key, index);
          if (target !== undefined) { event.preventDefault(); select(target, {focusTab: true}); }
        });
      });
      dots.forEach(dot => {
        listen(dot, 'click', () => select(Number(dot.dataset.reviewDot), {focusDot: true, reveal: true}));
        listen(dot, 'keydown', event => {
          const target = keyboardTarget(event.key, selectedIndex);
          if (target !== undefined) { event.preventDefault(); select(target, {focusDot: true, reveal: true}); }
        });
      });
      if (dock) {
        let touchStart;
        dock.addEventListener('touchstart', event => {
          touchStart = event.touches.length === 1 ? {x: event.touches[0].clientX, y: event.touches[0].clientY} : null;
        }, {signal: controller.signal, passive: true});
        dock.addEventListener('touchend', event => {
          if (!touchStart || !event.changedTouches.length) return;
          const dx = event.changedTouches[0].clientX - touchStart.x;
          const dy = event.changedTouches[0].clientY - touchStart.y;
          touchStart = null;
          if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            event.preventDefault();
            select(selectedIndex + (dx < 0 ? 1 : -1), {reveal: true});
          }
        }, {signal: controller.signal, passive: false});
        listen(dock, 'touchcancel', () => { touchStart = null; });
      }
      listen(track, 'keydown', event => {
        if (event.target !== track) return;
        const target = keyboardTarget(event.key, selectedIndex);
        if (target !== undefined) { event.preventDefault(); select(target, {reveal: true}); }
      });
      panels.forEach(panel => {
        const video = panel.querySelector('video');
        const cover = panel.querySelector('[data-review-play]');
        if (!video) return;
        panel.querySelectorAll('[data-review-play], [data-review-watch]').forEach(button => listen(button, 'click', () => {
          if (cover) cover.hidden = true;
          video.controls = true;
          video.muted = false;
          video.tabIndex = 0;
          video.focus({preventScroll: true});
          const bounds = video.getBoundingClientRect();
          if (bounds.bottom > innerHeight || bounds.top < 0) video.scrollIntoView({behavior: motion.matches ? 'auto' : 'smooth', block: 'center', inline: 'nearest'});
          const play = video.play();
          if (play?.catch) play.catch(() => { video.controls = true; });
        }));
        listen(video, 'ended', () => { if (cover) cover.hidden = false; });
      });
      let trackWidth = track.clientWidth;
      const resizeObserver = new ResizeObserver(() => {
        queueNavigation();
        if (trackWidth === track.clientWidth) return;
        trackWidth = track.clientWidth;
        pendingIndex = selectedIndex;
        track.scrollTo({left: offsetFor(selectedIndex), behavior: 'instant'});
      });
      resizeObserver.observe(track);
      resizeObserver.observe(root);
      const toolbarObserver = new MutationObserver(queueNavigation);
      toolbarObserver.observe(document.body, {childList: true});
      listen(window, 'scroll', queueNavigation);
      listen(window, 'resize', queueNavigation);
      if (window.visualViewport) listen(window.visualViewport, 'resize', queueNavigation);
      listen(root, 'shopify:block:select', event => {
        const index = panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
        if (index >= 0) select(index);
      });
      listen(document, 'shopify:section:unload', event => {
        if (!event.target.contains(root)) return;
        cancelAnimationFrame(scrollFrame);
        cancelAnimationFrame(navigationFrame);
        clearTimeout(settleTimer);
        portraitObserver?.disconnect();
        resizeObserver.disconnect();
        toolbarObserver.disconnect();
        controller.abort();
        delete root.dataset.reviewReady;
      });
      updateSelection(0);
      track.scrollTo({left: 0, behavior: 'instant'});
      syncNavigation();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["progressive-training"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initTraining(root) {
      const explorer = root.querySelector('[data-pt-explorer]');
      if (!explorer || explorer.classList.contains('is-ready')) return;
      const tablist = explorer.querySelector('[data-pt-tabs]');
      const tabs = Array.from(explorer.querySelectorAll('[data-pt-tab]'));
      const panels = Array.from(explorer.querySelectorAll('[data-pt-panel]'));
      if (!tabs.length || tabs.length !== panels.length) return;
      const select = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
      };
      tablist.setAttribute('role', 'tablist');
      const mobile = window.matchMedia('(max-width: 749px)');
      const orient = () => tablist.setAttribute('aria-orientation', mobile.matches ? 'horizontal' : 'vertical');
      orient();
      mobile.addEventListener('change', orient);
      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        // Keep the full routine name accessible when compact mobile labels are shown.
        tab.setAttribute('aria-label', tab.textContent.replace('↗', '').trim().replace(/\s+/g, ' '));
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        panels[index].tabIndex = 0;
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); select(next, true); }
        });
      });
      root.addEventListener('shopify:block:select', event => {
        const index = panels.findIndex(panel => panel === event.target || panel.contains(event.target));
        if (index >= 0) select(index);
      });
      select(0);
      explorer.classList.add('is-ready');
      tablist.hidden = false;
    }
    const init = scope => scope.querySelectorAll('[data-progressive-training]').forEach(initTraining);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    else init(document);
    document.addEventListener('shopify:section:load', event => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
